import React from 'react'
import styled from 'styled-components'
import { FaEdit, FaFileExport, FaTrash, FaCopy, FaUserShield } from 'react-icons/fa'

import LinkButton from './link-button'

const PaddedLinkButton = styled(LinkButton)`
  margin-left: 10px;
`

export const Delete = ({ onClick, title, size = 24 }) => (
  <PaddedLinkButton onClick={onClick} title={title}>
    <FaTrash size={size} />
  </PaddedLinkButton>
)

export const Edit = ({ onClick, title, size = 24 }) => (
  <PaddedLinkButton onClick={onClick} title={title}>
    <FaEdit size={size} />
  </PaddedLinkButton>
)

export const Permissions = ({ onClick, title, size = 24 }) => (
  <PaddedLinkButton onClick={onClick} title={title}>
    <FaUserShield size={size} />
  </PaddedLinkButton>
)

export const Export = ({ onClick, title, size = 24 }) => (
  <PaddedLinkButton onClick={onClick} title={title}>
    <FaFileExport size={size} />
  </PaddedLinkButton>
)

export const Copy = ({ onClick, title, size = 24 }) => (
  <PaddedLinkButton onClick={onClick} title={title}>
    <FaCopy size={size} />
  </PaddedLinkButton>
)
